import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "../css/Menu.css";
import { Icon } from 'component-lib';
import Vas from "../Vas";
import '../css/Menue.css';
import SideNavigation from './SideNavigation';

class Menue extends Component{

    
    logout(){
        Vas.Signout();
    }

    render(){
      
        return (
          <div className={"NavBar"}>
            <SideNavigation />
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td style={{ width: '60px' }}><Icon
                    Name={"Menu"}
                    Size={36}
                    Color={"white"}
                    OnClick={()=>{document.getElementById("mySidenav").style.width= "auto";}} /></td>
                  <td style={{ paddingBottom: '8px' }}><div id={"HeaderTitle"}>{Vas.Resources.Menus["Home"]}</div></td>
                  <td style={{ textAlign: 'right' }}>
                    <Link
                    style={{ fontSize: '20px', padding: '20px', textDecoration: 'none', color: 'white' }}
                    to={"/account"}><span >{ localStorage.getItem("vas_username")}</span></Link>
                    <Icon
                      Name={"SignOut"}
                      Size={36}
                      Color={"white"}
                      Align={"right"}
                      OnClick={()=>{ Vas.Signout();}} /></td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default Menue;
